function pricelistMenu() {
    function pricelistMenuRender() {
        let data = pricelistMenuData();
        if (data.menu && data.tariffSwiper) {
            pricelistMenuItemActive(data);
            pricelistMenuMobileToggleActive(data);
        }
    }

    function pricelistMenuData() {
        return {
            menu: document.querySelector('[data-selector="pricelist-tariff-menu"]'),
            menuItems: document.querySelectorAll('[data-selector="pricelist-tariff-menu-item"]'),
            tariffSwiper: document.querySelector('[data-selector="pricelist-swiper"]'),
            mobileBtn: document.querySelector('[data-selector="pricelist-tariff-menu-mobile-btn"]'),
        }
    }

    function pricelistMenuItemActive(data) {
        data.menuItems.forEach((item) => {
            item.addEventListener('click', function () {
                data.menuItems.forEach((item) => {
                    if (item.classList.contains('active')) {
                        item.classList.remove('active');
                    }
                });
                item.classList.add('active');
                pricelistMenuSetNewTarifData(pricelistMenuGetDataFromActiveItem(item));
                if (data.menu.classList.contains('open')) {
                    data.menu.classList.remove('open');
                }
            });
        });
    }

    function pricelistMenuGetDataFromActiveItem(item) {
        return {
            period: item.getAttribute('data-period'),
            tarif: {
                hobby: {
                    price: item.getAttribute('data-hobby'),
                    priceHint: item.getAttribute('data-hobby-hint'),
                },
                startup: {
                    price: item.getAttribute('data-startup'),
                    priceHint: item.getAttribute('data-startup-hint'),
                },
                business: {
                    price: item.getAttribute('data-business'),
                    priceHint: item.getAttribute('data-business-hint'),
                },
                individual: {
                    price: item.getAttribute('data-individual'),
                    priceHint: item.getAttribute('data-individual-hint'),
                },
            },
        };
    }

    function pricelistMenuSetNewTarifData(tarifData) {
        let tarifItems = document.querySelectorAll('[data-selector="pricelist-tarif-slide"]');
        tarifItems.forEach((item) => {
            let itemTarif = item.getAttribute('data-tarif');
            item.querySelector('[data-selector="pricelist-tarif-price-period"]').innerHTML = tarifData.period;
            item.querySelector('[data-selector="pricelist-tarif-price"]').innerHTML = tarifData.tarif[itemTarif].price;
            if (tarifData.tarif[itemTarif].priceHint.length === 0) {
                item.querySelector('[data-item="pricelist-swiper-slide-suffix"]').removeAttribute('data-toggle');
                item.querySelector('[data-item="pricelist-swiper-slide-suffix"]').removeAttribute('data-original-title');
            }
            else {
                item.querySelector('[data-item="pricelist-swiper-slide-suffix"]').setAttribute('data-toggle', 'tooltip');
                item.querySelector('[data-item="pricelist-swiper-slide-suffix"]').setAttribute('data-original-title', tarifData.tarif[itemTarif].priceHint);
            }
        });
    }

    function pricelistMenuMobileToggleActive(data) {
        data.mobileBtn.addEventListener('click', function () {
            data.menu.classList.toggle('open');
        });
    }

    document.addEventListener("DOMContentLoaded", function () {
        pricelistMenuRender();
        if (window.location.toString().includes("#tariff-inquiry-form")) {
            $('#pricelistSentModal').modal('show');
        }
    });
}
pricelistMenu();
